declare namespace $ {

	export class $mol_icon_instagram extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=instagram.view.tree.d.ts.map